import '../styles/about.css';
import { Helmet } from 'react-helmet-async';
import PAGE_SEO from '../data/pageSeo.json';

export const About = () => {

    return (
        <>
            <Helmet>
              <title>{PAGE_SEO.about.title}</title>
              <meta name="description" content={PAGE_SEO.about.description} />
              <link rel="canonical" href="https://stamsyart.bg/about" />
            </Helmet>
            <header>
            </header>
            <section className="landing-hero-wrapper">
                <div className="landinghero">
                    <div className="landinghero-bg pinkbg" />
                    <div className="landinghero-content">
                        <h1>Моят</h1>
                        <span>
                            <h3>
                                творчески <hr />
                            </h3>
                            <h2>СВЯТ</h2>
                        </span>
                        <div className="landing-bottomleft_deco">
                            <span />
                        </div>
                        <img
                            src="https://i.pinimg.com/236x/f6/08/d4/f608d4473d7f05cb4a2c86d24d7a7e35--picture-ideas-photo-ideas.jpg"
                            alt="Geenay Photo"
                        />
                    </div>
                </div>
            </section>
            <section className="graybg">
                <div className="width-wrapper">
                    <h2 className="slash-deco">Бързи факти</h2>
                    <ul>
                        <li>Всяка ръчно рисувана тениска е единствена по рода си и не може да бъде копирана, което я прави специално допълнение към всеки гардероб.</li>
                        <li>
                            Ръчно рисуваните продукти често се изработват с висококачествени материали и са внимателно създадени, за да осигурят издръжливост.
                        </li>
                        <li>
                            Процесът на създаване на ръчно рисувана тениска включва много време и усилия, като всяка отнема няколко часа или дори дни за завършване.
                        </li>
                        <li>Ръчно рисуваните тениски и подаръци са перфектни за специални случаи като рождени дни, годишнини и празници.</li>
                    </ul>
                </div>
            </section>
            <section>
                <div className="width-wrapper">
                    <h3 className="gray2">Малко повече</h3>
                    <p>
                        Добре дошли в нашия магазин Stamsy Art, където се специализираме в създаването на красиви ръчно рисувани тениски, подаръци и сувенири, които със сигурност ще привлекат вниманието. Нашият екип от талантливи художници работи неуморно, за да ви предостави уникални, единствени по рода си продукти, които няма да намерите другаде.

                        Всеки продукт е внимателно изработен с любов и внимание към детайла, гарантирайки че получавате нещо красиво. Използваме само най-добрите материали и всеки детайл е направен с прецизност и грижа.

                        Нашите ръчно рисувани тениски и подаръци са перфектни за тези, които искат да изразят своята индивидуалност и да се открояват от тълпата. Независимо дали търсите нещо смело и цветно, или нещо по-фино и елегантно, имаме продукт, който със сигурност ще отговаря на вашия стил.

                        Вярваме, че модата трябва да бъде забавна, креативна и достъпна за всеки. Затова предлагаме широк набор от размери, стилове и цветове.

                        Благодарим ви, че избрахте нашия магазин за вашите ръчно рисувани продукти. Надяваме се да се насладите на нашите изделия толкова, колкото ние се радваме да ги създаваме.
                    </p>
                </div>
            </section>
        </>
    );
};
